export default __webpack_public_path__ + "3edb93040494bba8ac22aeb0009c0efc.png";